import 'css-chunksrc/client/scenes/eventCreation/form/participantsList/resource/styles.scss';export default {
  "resource": "_resource_12zli_1",
  "iconBox": "_iconBox_12zli_18",
  "icon": "_icon_12zli_18"
};